export enum ColumnDropButtonTypeEnum {
  Filter = 'filter',
  Dimension = 'dimension',
  Serie = 'serie',
  Simple = 'simple',
  Statistics = 'statistics',
  Table = 'table',
  TablePivot = 'table-pivot',
  Sort = 'sort',
  Aggregation = 'aggregation',
  Scatter = 'scatter',
  ScatterBreakdown = 'scatter-breakdown',
  Breakdown = 'breakdown',
  Pie = 'pie',
  TreemapMeasure = 'treemap-measure',
  Numeric = 'numeric',
}

export const AllColumnDropButtonTypeComponents = {
  [ColumnDropButtonTypeEnum.Filter]: [],
  [ColumnDropButtonTypeEnum.Dimension]: [],
  [ColumnDropButtonTypeEnum.Serie]: [
    'mark',
    'stack',
    'stack_total',
    'format',
    'filter',
    /*'conditional_color',*/
    'percentage',
    'cumulate',
    'right_axis',
    'tooltip',
    'label',
    'connectNulls',
    'hideFalsyValues',
  ],
  [ColumnDropButtonTypeEnum.Simple]: [],
  [ColumnDropButtonTypeEnum.Statistics]: [],
  [ColumnDropButtonTypeEnum.Table]: [
    'format',
    'cell_type',
    'cell_settings',
    'table_header_aggregation_text',
    'rename',
    'display_name',
    'percentage',
  ],
  [ColumnDropButtonTypeEnum.TablePivot]: ['sort'],
  [ColumnDropButtonTypeEnum.Sort]: [],
  [ColumnDropButtonTypeEnum.Aggregation]: [],
  [ColumnDropButtonTypeEnum.Scatter]: ['min_max'],
  [ColumnDropButtonTypeEnum.ScatterBreakdown]: ['format', 'label', 'tooltip'],
  [ColumnDropButtonTypeEnum.Breakdown]: ['stack_total', 'format'],
  [ColumnDropButtonTypeEnum.Pie]: ['format', 'label', 'tooltip', 'size'],
  [ColumnDropButtonTypeEnum.TreemapMeasure]: ['measures_label', 'format', 'tooltip'],
  [ColumnDropButtonTypeEnum.Numeric]: [],
} as const;

export type ColumnDropButtonTypeComponents<T extends keyof typeof AllColumnDropButtonTypeComponents> = ReadonlyArray<
  (typeof AllColumnDropButtonTypeComponents)[T][number]
>;
